<template>
  <div class="liveList">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px">实景列表</span>
        <div class="head-text" style="float: right; margin-top: -4px">
          <el-select
            filterable
            v-model="types"
            style="margin-right: 20px"
            @change="selectlist"
            placeholder="请选择"
          >
            <el-option label="全部" value=" "></el-option>
            <el-option
              :label="item.Name"
              v-for="(item, index) in labelData"
              :key="index"
              :value="item.lbst03"
            ></el-option>
          </el-select>
          
          <el-button
            type="primary"
            @click="centerDialogVisible = true"
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('1071')) ||
              $store.state.isProject
            "
            >上传</el-button
          >
          <!-- v-permission="1071" -->
        </div>
      </div>
      <div class="rygl-table">
        <el-table
          align="center"
          class="margin-20 table"
          v-loading="loading"
          :data="userList"
          style="width: 100%"
          height="72vh"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column align="center" type="selection" width="55"></el-table-column> -->
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="55"
          ></el-table-column>
          <el-table-column align="center" prop="lbst03" label="资源类型">
            <template slot-scope="scope">{{
              scope.row.lbst03 == 1
                ? "照片"
                : scope.row.lbst03 == 2
                ? "全景链接"
                : "视频"
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobl04"
            label="名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mobl05"
            label="地点"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mobl06"
            label="拍摄时间"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="user04"
            label="上传用户"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mobl14"
            label="上传时间"
          ></el-table-column>
          <el-table-column align="center" prop="lbst03" label="绑定模型">
            <template slot-scope="scope">{{
              scope.row.mobl09 == null ? "否" : "是"
            }}</template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="seeLiveModel(scope.row)"
                >查看</el-button
              >
              <el-button
                size="small"
                v-if="scope.row.IsSelf"
                type="danger"
                plain
                @click="removeList(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="margin-top: 20px"
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[100, 50, 10]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 这里是上传 -->
    <el-dialog
      :close-on-click-modal="false"
      title="上传"
      :visible.sync="centerDialogVisible"
      width="40%"
      center
    >
      <el-row>
        <el-col :span="24">
          <el-form :model="Uploadingform" :rules="rules1" label-width="100px">
            <el-form-item label="选择类型">
              <el-select
                filterable
                style="width: 100%"
                v-model="UploadingName"
                @change="lebelXz"
                placeholder="请选择"
              >
                <el-option
                  :label="item.Name"
                  v-for="(item, index) in labelData"
                  :key="index"
                  :value="[item.lbst01, item]"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="输入链接："
              v-if="Uploadingform.lbst03 == 2"
              prop="mobl08"
            >
              <el-input
                v-model="Uploadingform.mobl08"
                placeholder="请输入链接"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="全景："
              prop="mobl07"
              v-if="Uploadingform.lbst03 == 1"
              style="width: 10%"
            >
              <el-checkbox v-model="Uploadingform.mobl07">是/否</el-checkbox>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form
            :model="Uploadingform"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="拍摄名称：" prop="mobl04">
              <el-input
                v-model="Uploadingform.mobl04"
                placeholder="请输入拍摄名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="拍摄地点：" prop="mobl05">
              <el-input
                v-model="Uploadingform.mobl05"
                placeholder="请输入拍摄地点"
              ></el-input>
            </el-form-item>
            <el-form-item label="拍摄时间：" prop="mobl06">
              <el-date-picker
                style="width: 100%"
                v-model="Uploadingform.mobl06"
                type="datetime"
                placeholder="选择日期时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px" v-if="Uploadingform.lbst03 != 2">
        <el-col :span="6" :offset="1">
          <div>
            <el-upload
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
              "
              :action="actionUrl2"
              class="upload-demo"
              :limit="1"
              :on-exceed="handleExceed"
              ref="upload"
              :data="Uploadingform"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handlesuccess"
              :on-change="handleChange"
              :on-error="errorS"
              :headers="importHeaders"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :auto-upload="false"
            >
              <el-button type="primary" plain slot="trigger">上传</el-button>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="centerDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="addUploading('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 这里是关联 -->
    <el-dialog
      :close-on-click-modal="false"
      title="关联选择集"
      :visible.sync="modelChooseListOpen"
      width="40%"
      center
    >
      <el-row>
        <el-col :span="10">
          <el-select
            filterable
            v-model="modelName"
            @change="handleClick"
            placeholder="请选择"
          >
            <el-option
              v-for="item in ModelList"
              :key="item.mode01"
              :label="item.mode02"
              :value="item.mode01"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="13" :offset="1">
          <!-- <div class="head-text" style="float:right;margin-top: -4px;">
            <el-input
              placeholder="请输入单位名称或用户姓名"
              style="width:200px"
              class="search-input"
              v-model="query2"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getData"
              style="margin-right:80px"
            ></el-button>
          </div> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="GetModelSelectList"
        tooltip-effect="dark"
        style="width: 100%; height: 400px; overflow: auto"
        @selection-change="handleSelectionChange"
      >
        <el-table-column width="30">
          <template slot-scope="scope">
            <el-radio
              v-model="ff"
              :label="scope.row"
              @change="preferenceSet"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="mosl02" label="名字"></el-table-column>
      </el-table>
      <el-row>
        <el-col :span="3" :offset="9">
          <el-button
            type="success"
            style="margin-left: 10px"
            @click="modelChooseListClose"
            >确定</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-button type="danger" @click="modelChooseListClose"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 关联资料 -->
    <el-dialog
      :close-on-click-modal="false"
      title="关联资料"
      :visible.sync="associatedData"
      width="80%"
      center
    >
      <el-row>
        <el-col
          :span="4"
          v-for="(item, index) in GetFilesLinksList2"
          :key="index"
        >
          <div style="border: 1px solid red">
            <el-row>
              <el-col :span="16">{{ item.prfl02 }}</el-col>
              <el-col :span="4">
                <el-button
                  size="small"
                  @click="deleteGetFilesLinksList2Item(index)"
                  >*</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-container>
        <el-aside width="200px">
          <el-tree
            :data="TreeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-aside>
        <el-main>
          <div class="head-text" style="float: right; margin-top: -4px">
            <!-- 新建事件 -->
            <el-input
              placeholder="请输入单位名称或用户姓名"
              style="width: 200px"
              class="search-input"
              v-model="query3"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              style="margin-right: 80px"
            ></el-button>
          </div>
          <el-table
            ref="multipleTable"
            :data="GetFilesLinksList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange2"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="prfl02" label="名字"></el-table-column>
          </el-table>
          <el-row>
            <el-col :span="3" :offset="9">
              <el-button type="success">上传资料</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="success" @click="associatedData = false"
                >确定关联</el-button
              >
            </el-col>
            <el-col :span="3">
              <el-button type="danger" @click="associatedDataClose"
                >取消</el-button
              >
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="查看"
      :visible.sync="ShowImg"
      width="50%"
      center
    >
      <iframe
        style="width: 100%; height: 600px"
        :src="showimgurl"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetProjectModelList,
  DelModelLabelSet,
  GetModelLabelSetList,
  GetModelSelect,
  GetModelLableSets,
  UploadModelLable,
} from "@/setAxios.js";
export default {
  name: "liveList",
  data() {
    return {
      type: "",
      showimgurl: "",
      ShowImg: false,
      // 上传label名称
      UploadingName: "",
      designForm: [],
      // 单选选择集固定值
      ff: {},
      // 单选选择集的对象
      hahaObjs: {},
      modelList: [],
      fileList: [],
      auList: [],
      ccList: [],
      // 这里是上传对话框
      centerDialogVisible: false,
      // tree配置
      defaultProps: {
        children: "children",
        label: "label",
      },
      TreeData: [],
      mid: "",
      modelName: "",
      GetModelSelectList: [],
      GetModelSelectList2: [],
      GetFilesLinksList: [],
      GetFilesLinksList2: [],
      loading: false,
      associatedData: false,
      userList: [],
      query: "",
      query2: "",
      query3: "",
      total: 0,
      pagesize: 10,
      pagenum: 1,
      multipleSelection: [],
      multipleSelection2: [],
      modelChooseListOpen: false,
      types: "全部",
      ModelList: [],
      groupType: [],
      FormData: {},
      form: {
        qid: localStorage.getItem("pid"),
        wkod10: localStorage.getItem("xid"),
        wkod11: localStorage.getItem("id"),
        wkod12: "",
        wkod14: null,
        wkod15: [],
      },
      Uploadingform: {
        mobl02: localStorage.getItem("xid"),
        lbst03: 1,
        mobl03: null,
        mobl04: null,
        mobl05: null,
        mobl06: null,
        mobl07: null,
        mobl08: null,
        mobl09: null,
        mobl10: null,
        mobl11: null,
        mobl12: null,
        mobl13: localStorage.getItem("id"),
        qid: localStorage.getItem("pid"),
      },
      importHeaders: { token: localStorage.getItem("token") },
      // 发起上传接口
      actionUrl2: this.$store.state.baseUrl + "/api/UploadModelLable",
      // label 对象
      labelData: null,
      // 表单判断
      rules: {
        mobl04: [
          { required: true, message: "请输入拍摄名称", trigger: "blur" },
        ],
        mobl05: [
          { required: true, message: "请输入拍摄地点", trigger: "blur" },
        ],
        typess: [
          { required: true, message: "请选择工作标签", trigger: "change" },
        ],
        mobl06: [
          {
            required: true,
            message: "请选择日期",
          },
        ],
      },
      rules1: {
        // mobl08: [{ required: true, message: "请输入链接名称", trigger: "blur" }]
      },
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    this.getData();
  },
  methods: {
    seeLiveModel(row) {
      this.ShowImg = true;
      this.showimgurl = this.$store.state.baseUrl + row.mobl08;
    },
    // 单选选择集
    preferenceSet(i) {
      //(i);
      this.Uploadingform.mobl09 = i.mosl03;
      this.Uploadingform.mobl10 = i.mosl12;
      this.Uploadingform.mobl11 = i.mosl11;
      this.Uploadingform.mobl12 = i.mosl10;
      this.hahaObjs = i;
    },
    // 选择列表类别
    selectlist(i) {
      this.type = i;
      this.getData();
    },

    // 模型关联
    pushModelIds(type) {
      //(type, this.GetModelSelectList2, "types");
      // wkod14模型选择接口目前只能接受一个int类型的ID,并不是数组ID
      this.GetModelSelectList2.forEach((item) => {
        this.form.wkod15.push(item.mosl01);
      });
    },
    deleteGetModelSelectList2Item(data) {
      //(data, "deleteGetModelSelectList2Item");

      this.GetModelSelectList2.splice(data, 1);
      this.pushModelIds("model");
      //(this.GetModelSelectList2);
    },
    handleSelectionChange(val) {
      var result = [];
      var obj = {};
      this.GetModelSelectList2.forEach((item) => {
        if (!obj[item.mosl01]) {
          result.push(item);
          obj[item.mosl01] = true;
        }
      });
      this.GetModelSelectList2 = result;
      this.pushModelIds();
    },
    deleteGetFilesLinksList2Item(data) {
      this.GetFilesLinksList2.splice(data, 1);
      this.pushModelIds("file");
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.multipleSelection = [];
          this.multipleSelection2 = [];
        })
        .catch((_) => {});
    },
    associatedDataOpen() {
      this.associatedData = true;
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileTree({ params }).then((res) => {
        this.TreeData = res.Data;
        if (res.Data.length !== 0) {
          this.fid = res.Data[0].ID;
          this.bb();
          //(res);
        }
      });
    },
    bb() {
      let params = {
        fid: this.fid,
        xid: localStorage.getItem("xid"),
        seachword: "",
        uid: localStorage.getItem("id"),
      };
      GetFilesLinks({ params }).then((res) => {
        this.GetFilesLinksList = res.Data;
        //(res);
      });
    },
    handleNodeClick(data) {
      this.fid = data.ID;
      this.bb();
      //(data);
    },
    deletemultipleSelection(data) {
      //(data);
      this.GetModelSelectList2.splice(data, 1);
      this.pushModelIds("model");
    },
    deletemultipleSelection2(data) {
      //(data);
      this.GetFilesLinksList2.splice(data, 1);
      this.pushModelIds("file");
    },
    aa() {
      let params = {
        seachword: this.query2,
        mid: this.mid,
      };
      GetModelSelect({ params }).then((res) => {
        //(res);
        this.GetModelSelectList = res.Data;
      });
    },
    modelChooseListClose() {
      this.modelChooseListOpen = false;
      this.multipleSelection = [];
    },
    associatedDataClose() {
      this.associatedData = false;
      this.multipleSelection2 = [];
    },
    // 这里是切换模型
    handleClick(data) {
      //(data);
      // this.GetModelSelectList2 = this.unique(this.GetModelSelectList2);
      this.mid = data;
      this.Uploadingform.mobl09 = data;
      this.aa();
    },
    // 这里是上传确定按钮
    addUploading(formName) {
      if (
        this.Uploadingform.mobl04 == null ||
        this.Uploadingform.mobl05 == null ||
        this.Uploadingform.mobl06 == null ||
        this.Uploadingform.mobl03 == null
      ) {
        this.$message({
          type: "warning",
          message: "表单填写有误",
        });
        return;
      }
      if (this.Uploadingform.lbst03 != 2) {
        if (this.$refs.upload.uploadFiles.length == 0) {
          this.$message({
            type: "warning",
            message: "没有上传附件",
          });
          return;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.centerDialogVisible = false;
            if (this.Uploadingform.mobl07 == true) {
              this.Uploadingform.mobl07 = 1;
            } else {
              this.Uploadingform.mobl07 = 0;
            }
            this.$refs.upload.submit();
            this.UploadingName = this.$options.data.call(this).UploadingName;
            this.Uploadingform = this.$options.data.call(this).Uploadingform;
            this.GetModelSelectList2 = [];
          } else {
            this.$message({
              type: "warning",
              message: "表单填写有误",
            });
            return false;
          }
        });
      } else {
        if (
          this.Uploadingform.lbst03 == 2 &&
          this.Uploadingform.mobl08 == null
        ) {
          this.$message({
            type: "warning",
            message: "请输入链接",
          });
          return;
        } else {
          UploadModelLable({ ...this.Uploadingform }).then((res) => {
            //(res, "全景链接提交");
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "上传成功",
              });
              this.getData();
              this.centerDialogVisible = false;
            } else {
              this.$message.error("提交失败");
            }
          });
        }
      }
    },
    // 这里获取所有数据
    getData() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        type: this.type,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
        fillter: "",
      };
      GetModelLabelSetList({ params }).then((res) => {
        this.total = res.Data.total;
        this.userList = res.Data.list;
        this.loading = false;
      });
      params = {
        xid: localStorage.getItem("xid"),
      };
      GetModelLableSets({ params }).then((res) => {
        this.Uploadingform.mobl03 = res.Data[0].lbst01;
        this.Uploadingform.lbst03 = res.Data[0].lbst03;
        this.UploadingName = res.Data[0].Name;
        this.labelData = res.Data;
      });
    },
    unique(arr, type) {
      if (type == "model") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].mosl01 == arr[j].mosl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      } else if (type == "file") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].prfl01 == arr[j].prfl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      }
      return arr;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      this.GetFilesLinksList2.push(...val);
      this.GetFilesLinksList2 = this.unique(this.GetFilesLinksList2, "file");
      this.pushModelIds("file");
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("form", JSON.stringify(this.Uploadingform));
    },
    //上传成功
    handlesuccess(response, file, fileList) {
      //(response, file, fileList, "sss");
      if (response.Code == 1) {
        this.$message({
          type: "success",
          message: "成功上传",
        });
        this.getData();
        this.Uploadingform = this.$options.data.call(this).Uploadingform;
        this.GetModelSelectList2 = [];
        this.fileList = [];
      } else {
        this.$message.error("上传失败");
      }
    },
    // 上传失败
    errorS(err, file, fileList) {
      //(err, file, fileList, "嘎嘎");
    },
    handlesuccesS(response, file, fileList) {
      this.$message({
        type: "success",
        message: "操作成功",
      });
      this.getData();
    },
    handleChange(file, fileList) {
      //(file, "file");
      // let name = file.name.substr(file.name.lastIndexOf("."));
      //(name);
      // const isnames =
      //   name.indexOf(".jpg") == 0
      //     ? true
      //     : name.indexOf(".png") == 0
      //     ? true
      //     : false;
      // const isLt500M = file.size / 1024 / 1024 > 500;
      // if (isLt500M) {
      //   this.$message({
      //     message: "上传文件大小不能超过500MB!",
      //     type: "warning",
      //   });
      //   this.fileList = [];
      // }
      // if (!isnames) {
      //   this.$message({
      //     message: "上传文件格式错误,应为 JPG 或 PNG 格式",
      //     type: "warning",
      //   });
      //   this.fileList = [];
      //   return false;
      // }
      // return isLt500M || isnames;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件！`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handlePreview(file) {
      //(file);
    },
    // 上传
    handleRemove(file, fileList) {
      //(file, fileList);
    },
    // 上传lable的变换
    lebelXz(i) {
      //(i);
      this.Uploadingform.lbst03 = i[1].lbst03;
      this.Uploadingform.mobl03 = i[0];
      this.UploadingName = i[1].Name;
    },
    removeList(row) {
      this.$confirm("是否删除该实景点位?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row.mobl01,
          };
          DelModelLabelSet(params).then((res) => {
            // //(res, "删除");
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getData();
              this.Uploadingform = this.$options.data.call(this).Uploadingform;
              this.GetModelSelectList2 = [];
              this.fileList = [];
            } else {
              this.$message.error("删除失败！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>
/deep/ .upload-demo ul {
  width: 100%;
  margin-left: 10px;
  margin-bottom: 10px;
}
.user .margin-20 {
  margin: 20px 0;
}
.user .search-input {
  width: 300px;
}
.user .page {
  padding: 5px 0;
  background-color: #d3dce6;
}
.user {
  .btnArr {
    margin-top: 10px;
  }
}

.yq-col:nth-child(1) {
  overflow: hidden;
  margin: 0 0 0 150px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(2) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(3) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(4) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.user-loading {
  display: flex;
  margin: 10px 0;
  p {
    margin: 8px 0 0 10px;
    span {
      color: #007acc;
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
